import request from '@/utils/request'
const qs = require('qs')

// 新增一条留言
export function addContactMsg (data) {
  return request({
    url: '/ooh-sys/v1/website/addcontactmsg',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 新增一条留言
export function getBiddingInfo (data) {
  return request({
    url: '/ooh-sys/v1/bidding/getbiddinginfo',
    method: 'post',
    data: qs.stringify(data)
  })
}
